<template>
  <div class="app-page-home">
    <div class="app-content app-content-often">
      <el-tabs class="app-content-often__tabs" v-model="active">
        <el-tab-pane :label="$t('home.AppStore')" name="AppStore">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="searchData"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="searchData"
              class="handle-box__search handle-box__search-top"
              v-model="searchKey"
              :placeholder="$t('home.searchKeyData')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('home.OAfile')" name="OA">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goLink"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goLink"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyWord')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('home.emailFile')" name="Email">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goLink"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goLink"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyWord')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane label="BPM" name="BPM">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goLink"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goLink"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyWord')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('home.knowledge')" name="Knowledge">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goLink"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goLink"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyWord')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('home.CloudDrive')" name="CloudDrive">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goLink"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goLink"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyWord')"
              maxlength="128"
              :clearable="true"
            >
            </el-input>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('home.baidu')" name="BAIDU">
          <div
            class="app-content-often__search app-content-often__top"
            :class="{ focus: focus }"
          >
            <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goBD"
            ></i>
            <el-input
              @blur="focus = false"
              @focus="focus = true"
              @keyup.enter.native="goBD"
              class="handle-box__search handle-box__search-top"
              v-model="bdSearchKey"
              :placeholder="$t('home.searchKeyBaidu')"
              maxlength="128"
              :clearable="true"
            >
              <!-- <span slot="prefix">{{$t('ajaxMsg.baidu')}}</span> -->
            </el-input>
            <!-- <i
              style="cursor: pointer;"
              class="app-content-search iconfont icon-sousuo"
              @click="goBD"
            ></i> -->
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="app-content app-content-all" v-if="allListOfTabs.length > 0">
      <div
        class="app-content__item"
        :style="{ width: layoutWidth, 'padding-bottom': '15px' }"
      >
        <div class="handle-box">
          <!-- 应用标签 -->
          <app-tabs
            v-model="currentId"
            :tabs="labelTabs"
            :change="changeTab"
            type="label"
            v-if="tabIsShow"
          ></app-tabs>
          <!-- 字母标签-->
          <app-tabs
            v-model="currentId"
            :tabs="tabs"
            :change="changeTab"
            type="letter"
            v-if="tabIsShow"
          ></app-tabs>
          <div style="margin-top: 40px;" v-if="oftenAppShow">
            <div
              class="app-content__item"
              :style="{ width: layoutWidth }"
              v-if="commonList.length > 0"
            >
              <div v-loading="isLoading" ref="oftenApp">
                <div class="label-all-list">
                  <div class="label-text-more" v-t="'home.often'">常用应用</div>
                </div>
                <app-list
                  ref="appList"
                  :is-drag="true"
                  v-model="commonList"
                  :handle-click="deleteAppOften"
                  :props="props"
                  :on-move="onMove"
                  :on-drag="onDrag"
                ></app-list>
              </div>
              <sw-error
                code="empty"
                v-if="!commonList.length && !isLoading"
              ></sw-error>
            </div>
          </div>
        </div>
        <div
          v-loading="allAppLoading"
          :style="{ 'min-height': '382px' }"
          v-if="!isEmpty"
        >
          <div v-for="item in allListOfTabs" :key="item.label">
            <div
              class="label-all-list"
              v-if="item.list.find((item) => item.show)"
            >
              <div class="label-text">{{ item.label }}</div>
            </div>
            <app-list
              v-model="item.list"
              :type="'all'"
              :handle-type="'add'"
              :props="props"
              :handle-click="addAppOften"
              :search="searchKey"
            ></app-list>
          </div>
        </div>
        <sw-error code="empty" v-else></sw-error>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import qs from 'qs';
import '@/web-pinyin/py';
import appList from './app-list';
import appTabs from '@/views/components/tabs';
import swError from '@/views/components/error';
import { GetSearchValue } from '@/utils';
import store from '@/store';

Vue.use(appTabs);
Vue.use(swError);
export default {
  name: 'appHome',
  beforeRouteEnter(to, from, next) {
    if (window.top === window.self) {
      next();
    }
  },
  created() {
    if (!this.loginUser) {
      this.$store.dispatch('global/domainLogin');
    } else {
      this.getAllApp();
      this.getFixedApp();
      this.getOftenApp();
      this.getAdsOftenApp();
      this.getLabelInfo();
      // this.ceshi();
    }
  },
  components: {
    appList
  },
  data() {
    return {
      currentId: 0,
      active: 'AppStore',
      activeName: 'all',
      allList: [],
      isEmpty: false,
      props: {
        url: 'managerUrl',
        name: 'appName',
        logo: 'appLogo',
        enName: 'appEName'
      },
      searchKey: '',
      fixedAppIds: [],
      isLoading: true,
      allAppLoading: true,
      bdSearchKey: '',
      isHover: false,
      focus: false,
      searchAllFocus: false,
      currentSearchData: [],
      currentSearchTab: {},
      tabIsShow: true,
      fixedAppList: [],
      selfAppList: [],
      adsSelfAppList: [],
      commonList: [],
      fixedList: [],
      labelList: [],
      oftenAppShow: true
    };
  },
  computed: {
    /**
     * 语言
     */
    currentLang() {
      return this.$i18n.locale;
    },
    /**
     * tabs字母标签参数
     */
    tabs() {
      let arr = [];
      let currentLetter =
        this.currentLang === 'en' ? this.searchEnLetter : this.searchLetter;
      currentLetter.map((item, index) => {
        let obj = {
          name: item,
          type: 'letter', // type 区分是否首字母
          searchKey: item,
          id: this.labelList.length + 1 + index
        };
        arr.push(obj);
      });
      return arr;
    },
    /**
     * 应用标签参数
     */
    labelTabs() {
      let labelArr = [
        {
          name: this.$t('home.allApp'),
          searchKey: 'all', // searchKey 记录当前搜索字段
          id: 0
        }
      ];
      const haveLabelList = this.labelList.filter((item) =>
        this.allListNew.some(
          (allItem) =>
            item.name === allItem.appLabel || item.name === allItem.appEnLabel
        )
      );
      haveLabelList.map((item, index) => {
        let obj = {
          name: this.currentLang === 'en' ? item.ename : item.name,
          searchKey: this.currentLang === 'en' ? item.ename : item.name,
          type: 'label',
          id: index + 1
        };
        labelArr.push(obj);
      });
      return labelArr;
    },
    /**
     * 页面最小宽度
     */
    layoutWidth() {
      return this.$store.state.global.layoutWidth + 'px';
    },
    loginUser(val) {
      return this.$store.state.global.loginInfo;
    },
    /**
     * 所有常用应用id
     */
    oftenAppIds() {
      let arr = [];
      for (let i = 0; i < this.commonList.length; i++) {
        arr.push(this.commonList[i].appId);
      }
      for (let i = 0; i < this.fixedList.length; i++) {
        arr.push(this.fixedList[i].appId);
      }
      return arr;
    },
    /**
     * 应用市场列表
     */
    allListNew() {
      let data = this.allList;
      for (let i = 0; i < data.length; i++) {
        if (this.oftenAppIds.indexOf(data[i].appId) > -1) {
          data[i].handleShow = false;
        } else {
          data[i].handleShow = true;
        }
      }
      return data;
    },
    /**
     * 中文名首字母作为key值的对象
     * @return {Object}
     */
    allAppLetter() {
      // 首字母作为key值的对象
      let data = this.allList;
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i].firstLetter] = data[i];
      }
      return obj;
    },
    /**
     * 英文名首字母作为key值的对象
     * @return {Object}
     */
    allAppEnLetter() {
      let data = this.allList;
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i].firstEnLetter] = data[i];
      }
      return obj;
    },
    /**
     * 26英文字母
     * @return {Array}
     */
    allChars() {
      const startChar = 65;
      const allChars = [];
      for (let i = 0; i < 26; i++) {
        allChars.push(String.fromCharCode(startChar + i));
      }
      return allChars;
    },
    /**
     * 所有应用中文名存在的首字母
     * @return {Array}
     */
    searchLetter() {
      let result = [];
      this.allChars.map((item, index, arr) => {
        if (this.allAppLetter[item]) result.push(item);
      });
      result.push('#');
      return result;
    },
    /**
     * 所有应用英文名存在的首字母
     * @return {Array}
     */
    searchEnLetter() {
      let result = [];
      this.allChars.map((item, index, arr) => {
        if (this.allAppEnLetter[item]) result.push(item);
      });
      result.push('#');
      return result;
    },
    /**
     * 模式
     * @return {string} '1' 浏览模式 入口在IT门户后台
     */
    pageMode() {
      return GetSearchValue('preview');
    },
    previewUrl() {
      return `preview=${this.pageMode}`;
    },
    allListOfTabs() {
      let lists = [];
      this.labelList.map((item) => {
        let listArr = [];
        this.allListNew.map((item2) => {
          if (item2.appLabel === item.name) {
            listArr.push(item2);
          }
        });
        lists.push({
          label: this.currentLang === 'en' ? item.ename : item.name,
          list: listArr
        });
      });
      const newlist = lists.filter((item) => item.list.length > 0);
      return newlist;
    }
  },
  watch: {
    selfAppList(val) {
      let adsList = [];
      for (let i = 0; i < this.adsSelfAppList.length; i++) {
        let flag = true;
        for (let j = 0; j < val.length; j++) {
          if (this.adsSelfAppList[i].appId === val[j].appId) {
            flag = false;
          }
        }
        if (flag) {
          adsList.push(this.adsSelfAppList[i]);
        }
      }
      this.commonList = [...adsList, ...val];
    },
    adsSelfAppList(val) {
      let adsList = [];
      for (let i = 0; i < val.length; i++) {
        let flag = true;
        for (let j = 0; j < this.selfAppList.length; j++) {
          if (val[i].appId === this.selfAppList[j].appId) {
            flag = false;
          }
        }
        if (flag) {
          adsList.push(this.adsSelfAppList[i]);
        }
      }
      this.commonList = [...adsList, ...this.selfAppList];
    },
    fixedAppList(val) {
      // this.commonList = [...val];
      this.fixedList = [...val];
    },
    searchKey(val) {
      if (!val && this.currentId === 0) {
        this.oftenAppShow = true;
        store.commit('global/SET_PAGE_HEIGHT', true);
      } else {
        this.oftenAppShow = false;
        store.commit('global/SET_PAGE_HEIGHT', false);
      }
      this.searchData();
    },
    /**
     * 登录用户更改或者登录过期需要重新登录重新获取数据
     */
    loginUser(val, oldVal) {
      if (!val) {
        this.$store.dispatch('global/domainLogin');
      } else {
        this.getAllApp();
        this.getFixedApp();
        this.getOftenApp();
        this.getAdsOftenApp();
        this.getLabelInfo();
        // 搜索状态重置
        this.searchKey = '';
        this.currentId = 0;
        this.tabIsShow = false;
        setTimeout(() => {
          this.tabIsShow = true;
        });
      }
    },
    currentSearchTab(val, oldVal) {
      if (val !== oldVal) {
        this.searchData();
      }
    },
    currentLang() {
      this.changeLangReset();
    }
  },
  methods: {
    /**
     * tab搜索回调
     */
    changeTab(item) {
      this.currentSearchTab = item;
      if (item.searchKey === 'all' && !this.searchKey) {
        this.oftenAppShow = true;
        store.commit('global/SET_PAGE_HEIGHT', true);
      } else {
        this.oftenAppShow = false;
        store.commit('global/SET_PAGE_HEIGHT', false);
      }
    },
    /**
     * 搜索
     */
    searchData() {
      this.currentSearchTab = this.currentSearchTab || this.labelTabs[0];
      this.isEmpty = true;
      let searchKey = this.searchKey;
      let tabSearchKey = this.currentSearchTab.searchKey || 'all';
      let tabType = this.currentSearchTab.type;
      let data = this.allList;
      let filterName =
        this.currentLang === 'en' ? this.props.enName : this.props.name;
      let letter = this.currentLang === 'en' ? 'firstEnLetter' : 'firstLetter';
      if (this.searchKey) {
        if (tabSearchKey !== 'all') {
          if (tabType === 'label') {
            // 标签和模糊字段同时筛选
            for (let i = 0; i < data.length; i++) {
              if (
                (data[i][filterName]
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1 ||
                  data[i][filterName]
                    .toLowerCase()
                    .indexOf(searchKey.toLowerCase()) > -1) &&
                (data[i].appLabel === tabSearchKey ||
                  data[i].appEnLabel === tabSearchKey)
              ) {
                data[i].show = true;
                this.isEmpty = false;
              } else {
                data[i].show = false;
              }
            }
          } else {
            // 字母和模糊字段同时筛选
            for (let i = 0; i < data.length; i++) {
              if (
                (data[i][filterName]
                  .toUpperCase()
                  .indexOf(searchKey.toUpperCase()) > -1 ||
                  data[i][filterName]
                    .toLowerCase()
                    .indexOf(searchKey.toLowerCase()) > -1) &&
                data[i][letter] === tabSearchKey
              ) {
                data[i].show = true;
                this.isEmpty = false;
              } else {
                data[i].show = false;
              }
            }
          }
        } else {
          // 仅仅模糊字段筛选
          for (let i = 0; i < data.length; i++) {
            if (
              data[i][filterName]
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1 ||
              data[i][filterName]
                .toLowerCase()
                .indexOf(searchKey.toLowerCase()) > -1
            ) {
              data[i].show = true;
              this.isEmpty = false;
            } else {
              data[i].show = false;
            }
          }
        }
      } else {
        if (tabSearchKey !== 'all') {
          if (tabType === 'label') {
            // 仅仅标签筛选
            for (let i = 0; i < data.length; i++) {
              if (
                data[i].appLabel === tabSearchKey ||
                data[i].appEnLabel === tabSearchKey
              ) {
                data[i].show = true;
                this.isEmpty = false;
              } else {
                data[i].show = false;
              }
            }
          } else {
            // 仅仅字母筛选
            for (let i = 0; i < data.length; i++) {
              if (data[i][letter] === tabSearchKey) {
                data[i].show = true;
                this.isEmpty = false;
              } else {
                data[i].show = false;
              }
            }
          }
        } else {
          // 无筛选
          let dflag = false;
          for (let i = 0; i < data.length; i++) {
            if (data[i].appName.startsWith('调拨') && !dflag) {
              data[i].show = false;
              dflag = true;
            } else {
              data[i].show = true;
              this.isEmpty = false;
            }
          }
        }
      }
      // this.allListOfTabs = this.allListOfTabs.filter(item => item.list.find((val) => val.show));
    },
    /**
     * 移除常用应用
     */
    deleteAppOften(item) {
      let url = `/api/app/info/portal/user/app/delete?tenantId=${this.loginUser.tenantId}&appId=${item.appId}`;
      this.axios.delete(url).then((res) => {
        if (res.code === 'success') {
          this.removeOftenApp(item);
          this.$message({
            type: 'success',
            message: this.$t('others.delSuc')
          });
          this.allList.forEach((val) => {
            // // 解决滚动条跳动popover不消失问题
            if (item.appId === val.appId) val.popDisabled = false;
          });
        }
      });
    },
    /**
     * 增加常用应用
     */
    addAppOften(item) {
      let params = {
        tenantId: this.loginUser.tenantId,
        appId: item.appId
      };
      this.axios
        .post('/api/app/info/portal/user/app/add', qs.stringify(params))
        .then((res) => {
          if (res.code === 'success') {
            item.drag = true;
            item.popDisabled = true; // 解决滚动条跳动不消失问题
            let newItem = { ...item, ...{ popDisabled: false } };
            this.selfAppList.push(newItem);
            this.$message({
              type: 'success',
              message: this.$t('others.addSuc')
            });
            // this.changeScroll();
          }
        });
    },
    /**
     * 添加常用应用之后把当前元素定位到屏幕可视区域
     */
    changeScroll() {
      let appListTop =
        Math.floor(this.commonList.length / 5) > 2
          ? (Math.floor(this.commonList.length / 5) - 1) * 208
          : 0;
      window.scrollTo(0, this.$refs.oftenApp.offsetTop + appListTop);
    },
    /**
     * 获取固定应用
     */
    getFixedApp() {
      let url = `/api/app/info/portal/config/app/fixed`;
      if (this.pageMode === '1') url = url + `?${this.previewUrl}`;
      return this.axios.get(url).then((res) => {
        if (res.code === 'success') {
          let data = res.data || [];
          this.fixedAppList = data.map(function (item) {
            item.handleShow = false;
            return item;
          });
        }
      });
    },
    /**
     * 获取大数据提供常用应用
     */
    getAdsOftenApp() {
      this.isLoading = true;
      let url = `/api/app/info/portal/config/app/ads`;
      if (this.pageMode === '1') url = url + `?${this.previewUrl}`;
      return this.axios.get(url).then((res) => {
        if (res.code === 'success') {
          this.isLoading = false;
          let data = res.data || [];
          this.adsSelfAppList = data.map(function (item) {
            item.handleShow = false;
            return item;
          });
        }
      });
    },
    /**
     * 获取用户添加常用应用
     */
    getOftenApp() {
      this.isLoading = true;
      let url = `/api/app/info/portal/user/app/list`;
      if (this.pageMode === '1') url = url + `?${this.previewUrl}`;
      this.axios.get(url).then((res) => {
        if (res.code === 'success') {
          this.isLoading = false;
          let data = res.data || [];
          this.selfAppList = data.map(function (item) {
            item.handleShow = true;
            item.drag = true;
            item.popDisabled = false;
            return item;
          });
        }
      });
    },
    /**
     * 获取应用市场列表
     */
    getAllApp() {
      this.allAppLoading = true;
      let url = `/api/app/info/portal/app/list/all`;
      if (this.pageMode === '1') url = url + `?${this.previewUrl}`;

      this.axios.get(url).then((res) => {
        if (res.code === 'success') {
          this.allAppLoading = false;
          let dflag = false;
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i][this.props.name].startsWith('调拨') && !dflag) {
              dflag = true;
              res.data.push(Object.assign({}, res.data[i]));
              res.data[i].show = false;
              res.data[i].handleShow = true;
              res.data[i].popDisabled = false;
              res.data[i].firstLetter = 'D';
              res.data[i].firstEnLetter = 'D';
            } else {
              res.data[i].show = true;
              res.data[i].handleShow = true;
              res.data[i].popDisabled = false;
              res.data[i].firstLetter = this.getFirstLetter(
                res.data[i][this.props.name]
              );
              res.data[i].firstEnLetter = this.getFirstLetter(
                res.data[i][this.props.enName]
              );
            }
          }
          this.allList = res.data;
          let diaoApp = this.allList.find((app) =>
            app.appName.startsWith('调拨')
          );
          this.$set(diaoApp, 'firstLetter', 'D');
          this.$set(diaoApp, 'firstEnLetter', 'D');
        }
      });
    },
    // 获取标签列表
    getLabelInfo() {
      this.axios
        .get('/api/app/info/portal/app/labels', qs.stringify())
        .then((res) => {
          if (res.code === 'success') {
            this.labelList = res.data;
          }
        });
    },
    /**
     * 从常用应用列表中删除
     */
    removeOftenApp(item) {
      for (let i = 0; i < this.selfAppList.length; i++) {
        if (this.selfAppList[i].appId === item.appId) {
          let index = this.selfAppList.indexOf(this.selfAppList[i]);
          this.selfAppList.splice(index, 1);
        }
      }
    },
    /**
     * 百度搜索
     */
    goBD() {
      if (this.bdSearchKey) {
        window.open(`https://www.baidu.com/s?wd=${this.bdSearchKey}`);
      }
    },

    getCookie(cname) {
      let name = cname + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
    },
    /**
     * ilink搜索
     */
    goLink() {
      // window.open(`https://ilink.geely-test.com/?token=${this.loginUser.ticket}&searchType=${this.active}&keyWord=${this.bdSearchKey}&loginSource=3`)
      window.open(
        `https://ilinksearch.geely.com/?token=${this.loginUser.ticket}&searchType=${this.active}&keyWord=${this.bdSearchKey}&loginSource=3`
      );
    },
    /**
     * 首字母转换
     */
    getFirstLetter(str) {
      if (!str) return;
      // let letter = PY(str, { style: PY.STYLE_FIRST_LETTER })[0]
      let letter = window
        .py(str, { style: window.py.STYLE_FIRST_LETTER })[0]
        .join()
        .toUpperCase();
      let result = letter;
      if (letter.length > 1) {
        // 例如出现OA门户解析完之后会是OA 需特殊处理
        result = letter.substring(0, 1);
      }
      if (this.allChars.indexOf(result) < 0) result = '#';
      return result;
    },
    /**
     * 切换语言时应用市场初始化
     */
    changeLangReset() {
      this.currentSearchTab = {
        name: this.$t('home.allApp'),
        searchKey: 'all', // searchKey 记录当前搜索字段
        id: 0
      };
      this.currentId = 0;
      this.searchKey = '';
    },
    /**
     * 拖拽回调
     * @param {Object} e 当前拖拽项数据
     * @param {Number} newIndex 新索引
     * @param {Number} oldIndex 旧索引
     */
    onDrag(e, newIndex, oldIndex) {
      let params = {
        appId: e.appId,
        sortBy: newIndex - this.adsSelfAppList.length + 1
      };
      this.axios.put(
        '/api/app/info/portal/config/app/order',
        qs.stringify(params)
      );
    },
    /**
     * 移动时钩子
     * @param {Object} e 当前拖拽项model
     * @param {newIndex} newIndex 新索引
     * @return {Boolean} 索引大于固定应用索引时可拖拽
     */
    onMove(e, newIndex) {
      return newIndex > this.adsSelfAppList.length - 1;
    }
  }
};
</script>
<style src="./index.scss" scoped lang="scss"></style>
<style lang="scss">
.app-page-home {
  background-image: url("./images/tu-shang@2x.png");
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100% 1000px;

  .handle-box__search {
    .el-input__inner {
      border: 1px solid rgba(153, 153, 153, 0.5);
      border-radius: 30px;
      font-size: 16px;
      height: 60px;
      padding-left: 27px;
      padding-right: 60px;
    }

    .el-input__suffix {
      line-height: 60px;
      right: 30px;

      i {
        color: #c0c4cc;
        font-size: 20px;
      }
    }

    &-all {
      position: absolute;
      right: 0;
      // top: 10px;
      top: 16px;
      transition: all 0.3s;
      width: 128px;

      &.en {
        width: 155px;
      }

      &:hover,
      &.active {
        width: 230px;
      }

      &:hover,
      &.searchAllFocus {
        .el-input__inner {
          border: 1px solid #28e;
          // box-shadow: 0 0 8px 0 rgba(34, 136, 238, 0.15);
          box-shadow: 0 0 15px 0 rgba(118, 168, 241, 0.3);
        }

        .el-input__suffix i {
          color: #28e;
        }
      }
    }

    &-top {
      display: block;

      .el-input__inner {
        border: none;
        // box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 0 15px 0 rgba(118, 168, 241, 0.3);
        padding-left: 56px;
        padding-right: 56px;
      }

      .el-input__prefix {
        // border-right: 1px solid rgba(153, 153, 153, 0.3);
        color: #333;
        font-size: 16px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        top: 50%;
        transform: translateY(-50%);
        width: 114px;
      }

      .el-input__suffix {
        right: 30px !important;
      }
    }
  }

  .app-content-often {
    &__tabs {
      margin: 0 auto;
      width: 600px;

      .el-tabs__header {
        margin: 0 0 0 24px;
        width: 600px;
      }

      .el-tabs__content {
        border-radius: 30px;
        box-shadow: 0 0 15px 0 rgba(118, 168, 241, 0.3);
      }

      .el-tabs__item {
        color: #646a73;
        font-size: 14px;
        height: 32px;
        line-height: 22px;
        // margin: 0 8px;
        padding: 4px 8px !important;
        text-align: center;
        // font-weight: 600;
      }

      .el-tabs__item.is-active {
        // background: #ECF2FE;
        background:
          linear-gradient(
            180deg,
            #b3d2ff 0%,
            rgba(255, 255, 255, 0) 100%
          );
        border-radius: 20px;
        // color: #005DE5;
        color: #000;
        font-size: 16px;
      }

      .el-tabs__item:hover {
        color: #000;
      }

      .el-tabs__active-bar,
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }

    &__top {
      &:hover,
      &.focus {
        .el-input__inner {
          // border: 1px solid #28e;
          // box-shadow: 0 0 8px 0 rgba(34, 136, 238, 0.15);
          box-shadow: 0 0 15px 0 rgba(118, 168, 241, 0.3);
        }

        .app-content-search {
          // color: #28e;
        }
      }
    }
  }
}
</style>
